// extracted by mini-css-extract-plugin
module.exports = {"csr_h5_F":"F_csr_h5_F__xadkf"};